import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';

import AboutInfo from './AboutInfo/AboutInfo';

import cl from './About.module.css';

const About = (props) => {
  const position = props.aboutData.coordinates?.split(', ') || [
    40.808712, -73.946818,
  ];

  return (
    <section className={cl.app_about}>
      <AboutInfo shopStory={props.aboutData.story} />
      <div className={cl.contacts}>
        <h1>Contacts</h1>
        <MapContainer
          center={position}
          zoom={12}
          scrollWheelZoom={false}
          style={{
            height: '400px',
            maxWidth: '500px',
            width: '100%',
            margin: '0 auto',
            marginBottom: '1.5rem',
          }}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={position} />
        </MapContainer>
        <div style={{ textAlign: 'left', maxWidth: '500px', width: '100%' }}>
          <p>
            Email:{' '}
            <a
              style={{ color: 'var(--primary)' }}
              href={'mailto: support@' + props.aboutData.domain}
            >
              support@{props.aboutData.domain}
            </a>
          </p>
          <p>{props.aboutData.shopName} Group</p>
          <p>{props.aboutData.address}</p>
          <p>
            Tel:{' '}
            <a style={{ color: 'var(--primary)' }} href="tel:+18464947855">
              1-846-494-7855 x844
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
